import { computed, ComputedRef } from "vue";

import { USER } from "@/constants/user.constants";
import { useOrganizationStore } from "@/stores/organization.store";
import { useUsersStore } from "@/stores/users.store";

export const useLogsAccess = (): {
  canUserAccessLogs: ComputedRef<boolean>;
  isLogsAccessLoading: ComputedRef<boolean>;
} => {
  const orgStore = useOrganizationStore();
  const usersStore = useUsersStore();

  // The organisation and the current user load after the first navigation,
  // so a direct link to /logs reaches the page before they are known.
  // Callers must wait for this before treating `canUserAccessLogs` as false.
  const isLogsAccessLoading = computed<boolean>(() => {
    return orgStore.isOrganizationLoading || usersStore.areUsersLoading;
  });

  const canUserAccessLogs = computed<boolean>(() => {
    return (
      orgStore.canOrgManageLogs &&
      !!usersStore.currentUser &&
      USER.isInternalUser(usersStore.currentUser.type ?? 0) &&
      usersStore.canUserManageUsers
    );
  });

  return { canUserAccessLogs, isLogsAccessLoading };
};
